import EmployeeConatacts from '../components/EmployeeConatacts'

export default EmployeeConatacts;